import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { buildApiUrl, buildRequestHeaders } from '@dental-ui/shared/consts';
import { ResponseModel, PaginationResponseData } from '@dental-ui/account/models';
import { UserBranchDto, UserBranchFilterRequest } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserBranchApiService {
  private readonly http = inject(HttpClient);

  /**
   * Tüm kullanıcı şubelerini getirir
   * @param authorize - Authorization header'ı eklenip eklenmeyeceği (varsayılan: true)
   * @returns Kullanıcı şube listesi
   */
  getAllUserBranches(
    authorize = true
  ): Observable<ResponseModel<UserBranchDto[]>> {
    return this.http.get<ResponseModel<UserBranchDto[]>>(
      this.buildApiUrl('userBranch.getAll'),
      {
        headers: buildRequestHeaders(authorize),
      }
    );
  }

  /**
   * Role ID ve filtre ile kullanıcı şubelerini getirir
   * @param roleId - Rol ID'si
   * @param request - Filtreleme ve sayfalama parametreleri
   * @param authorize - Authorization header'ı eklenip eklenmeyeceği (varsayılan: true)
   * @returns Paginated kullanıcı şube listesi
   */
  getAllUserBranchByRoleIdAndFilter(
    roleId: string,
    request: UserBranchFilterRequest,
    authorize = true
  ): Observable<ResponseModel<PaginationResponseData<UserBranchDto>>> {
    const params = new HttpParams().set('roleId', roleId);
    
    return this.http.post<ResponseModel<PaginationResponseData<UserBranchDto>>>(
      this.buildApiUrl('userBranch.getAllByRoleIdAndFilter'),
      {
        PaginationRequestModel: {
          Page: request.paginationRequestModel.page + 1,
          NumberOfRecord: request.paginationRequestModel.numberOfRecord,
          SortColumn: request.paginationRequestModel.sortColumn,
          SortOrder: request.paginationRequestModel.sortOrder,
        },
        UserBranchFilterRequestDto: {
          userFirstName: request.userBranchFilterRequestDto.userFirstName || '',
          userLastName: request.userBranchFilterRequestDto.userLastName || '',
          branchDescription: request.userBranchFilterRequestDto.branchDescription || '',
          branchId: request.userBranchFilterRequestDto.branchId || '',
        },
      },
      {
        params,
        headers: buildRequestHeaders(authorize),
      }
    );
  }

  /**
   * Kullanıcının şubelerindeki tüm kullanıcıları getirir
   * @param userId - Kullanıcı ID'si
   * @param authorize - Authorization header'ı eklenip eklenmeyeceği (varsayılan: true)
   * @returns Kullanıcı şube listesi
   */
  getAllUserBranchByUserWithBranchId(
    userId: string,
    authorize = true
  ): Observable<ResponseModel<UserBranchDto[]>> {
    const params = new HttpParams().set('user', userId);

    return this.http.get<ResponseModel<UserBranchDto[]>>(
      this.buildApiUrl('userBranch.getAllUserBranchByUserWithBranchId'),
      {
        params,
        headers: buildRequestHeaders(authorize),
      }
    );
  }

  protected buildApiUrl(endpointPath: string): string {
    return buildApiUrl(endpointPath);
  }
}

